import React, { Component } from 'react'
import { headersForDataList } from './fixtures.js'
import DataTemplate from './dataTemplate.jsx'
import { connect } from 'react-redux'
import {
    addFile,
    removeFile,
    getFiles,
    addServices,
} from '../../redux/actions/items.js'
import { clientSide } from '../../config_react.js'

const { redirectToStorage } = clientSide[0]

const uuidv4 = require('uuid/v4')

class dataList extends Component {
    state = {
        openBlockId: null,
        loading: false,
    }

    render() {
        const requiredData = this.createFileList().map((item, i) => {
            let openKey = item.apiProperty
                ? item.apiProperty
                : item.serialNumber

            return (
                <DataTemplate
                    key={i}
                    title={item.title}
                    value={item.value}
                    apiProperty={item.apiProperty}
                    reduxProperty={item.reduxProperty}
                    updateData={this.updateData}
                    loadingProcess={this.loadingProcess}
                    serialNumber={
                        isNaN(item.serialNumber) ? null : item.serialNumber
                    }
                    servicesList={this.props.listOfServices}
                    userPermissions={item.userPermissions}
                    driveFileId={item.driveFileId ? item.driveFileId : null}
                    loading={this.state.loading}
                    isOpen={openKey === this.state.openBlockId}
                    toogleOpen={this.toogleOpen(openKey)}
                    openBlockId={this.state.openBlockId}
                    translate={this.props.translate}
                    enableNotification={this.props.enableNotification}
                />
            )
        })

        return <ul>{requiredData}</ul>
    }

    toogleOpen = openBlockId => {
        return ev => {
            if (this.state.openBlockId === openBlockId) {
                this.setState({ openBlockId: null })
            } else {
                this.setState({ openBlockId })
            }
        }
    }

    createFileList = () => {
        let resultArr = []
        let listOfFiles = this.props.listOfFiles
        let translate = this.props.translate

        headersForDataList.forEach(item => {
            if (listOfFiles[item.apiProperty]) {
                resultArr.push({
                    //title          : item.titleRu,
                    title: translate[`${item.title}`],
                    value: listOfFiles[item.apiProperty].name,
                    apiProperty: item.apiProperty,
                    userPermissions:
                        listOfFiles[item.apiProperty].userPermissions,
                    driveFileId: listOfFiles[item.apiProperty].driveFileId,
                })
            } else {
                resultArr.push({
                    title: translate[`${item.title}`],
                    value: null,
                    apiProperty: item.apiProperty,
                })
            }
        })

        let otherFiles = listOfFiles['other']

        if (otherFiles) {
            otherFiles.forEach((item, i) => {
                resultArr.push({
                    title: translate['Another file'],
                    value: otherFiles[i].name,
                    apiProperty: 'other',
                    serialNumber: i++,
                    userPermissions: item.userPermissions,
                    driveFileId: item.driveFileId,
                })
            })
        }

        resultArr.push({
            title: translate['Another file'],
            value: null,
            reduxProp: 'other',
            serialNumber: 0,
        })

        return resultArr
    }

    loadingProcess = () => {
        this.setState({
            loading: !this.state.loading,
        })
    }

    updateData = () => {
        this.props.getFiles()
    }
}

const mapStateToProps = state => {
    return {
        file: state.addFile,
        removeFile: state.removeFile,
        dataCollection: state.AddFiles,
        listOfFiles: state.AddFilesList,
        listOfServices: state.ServicesList,
    }
}

const mapDispatchProps = dispatch => {
    return {
        addFile: file => dispatch(addFile(file)),
        removeFile: file => dispatch(removeFile(file)),
        getFiles: address => dispatch(getFiles(address)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchProps
)(dataList)
